"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Fade: function() {
        return Fade;
    },
    FadeExaggerated: function() {
        return FadeExaggerated;
    },
    FadeSnappy: function() {
        return FadeSnappy;
    }
});
const _reactmotion = require("@fluentui/react-motion");
const duration = _reactmotion.motionTokens.durationNormal;
const easing = _reactmotion.motionTokens.curveEasyEase;
/** Define a presence motion for fade in/out  */ const fadeMotion = {
    enter: {
        duration,
        easing,
        keyframes: [
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ]
    },
    exit: {
        duration,
        easing,
        keyframes: [
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ]
    }
};
const Fade = (0, _reactmotion.createPresenceComponent)(fadeMotion);
const FadeSnappy = (0, _reactmotion.createPresenceComponentVariant)(Fade, {
    all: {
        duration: _reactmotion.motionTokens.durationFast
    }
});
const FadeExaggerated = (0, _reactmotion.createPresenceComponentVariant)(Fade, {
    all: {
        duration: _reactmotion.motionTokens.durationGentle
    }
});
